// extracted by mini-css-extract-plugin
module.exports = {"regionLoading":"src-common-region-loading-region-loading__regionLoading--2MxpN","sliding":"src-common-region-loading-region-loading__sliding--J5Gqi"};